import Cookies from 'js-cookie';
import buildApiRequestConfig from '../api/url-builder';
import routes from '../api/routes';

const authHeaders = (token: string): HeadersInit => ({
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
});

// Tells the server to end this login's session (express-server
// session-service.js) so the token stops working immediately - otherwise it
// would stay valid server-side until its own expiry even after the cookies
// are cleared. Fire-and-forget, and `keepalive` lets it finish even though
// the page navigates to /login right after. Call BEFORE removing the cookie.
export const endServerSession = () => {
    const token = Cookies.get('token');
    if (!token) return;
    const { url, method } = buildApiRequestConfig(routes.user.logout);
    fetch(url, { method, headers: authHeaders(token), keepalive: true }).catch(() => { /* best-effort */ });
};

// Keeps the server-side session alive while the user is actively working on a
// page that isn't making its own API calls. Resolves false when the server
// says the session has already ended (401), so the caller can sign out.
export const sendSessionHeartbeat = async (): Promise<boolean> => {
    const token = Cookies.get('token');
    if (!token) return false;
    const { url, method } = buildApiRequestConfig(routes.user.sessionHeartbeat);
    try {
        const res = await fetch(url, { method, headers: authHeaders(token) });
        return res.status !== 401;
    } catch {
        // Network hiccup - not a reason to sign anyone out.
        return true;
    }
};
